<template>
  <BaseModal :state="state" :open="open" :close="onClose">
    <template #header>
      <HeaderModalEvidencia
        :show-progress="state.header?.showProgress"
        :show-navigation="state.header?.showEvidenciaNavigation"
        :evidencia="state.data?.evidencia"
        @click:change="(v) => setState({ data: v })"
      />
    </template>
    <template #content>
      <div v-if="abaAtiva !== 'Default'" class="px-24 pt-24">
        <OButton
          secondary
          size="md"
          class="text-headline-4"
          @click="abaAtiva = 'Default'"
        >
          <q-icon
            size="1.25rem"
            color="icon-100"
            name="svguse:#icon_back"
          />
          {{ t('goBackAction') }}
        </OButton>
      </div>

      <KeepAlive>
        <component
          :is="componentes[abaAtiva]"
          ref="sectionRef"
          :alternativa="state.data.alternativa"
        />
      </KeepAlive>

      <FooterEvidenciaDefault
        :aba-ativa="abaAtiva"
        :alternativa="state.data.alternativa"
        @click:save="onClickSave"
        @changeAba="onChangeAba"
      />

      <BaseInnerLoader
        v-if="loading.evidencia?.enviando"
        :percent="loading.evidencia?.porcentagem"
      />
    </template>
  </BaseModal>
</template>

<script setup>
import { NotifyError } from 'js/vue/boot/Notify'
import { ref } from 'vue'
import { useEvidencia } from 'composables/useEvidencia'
import { useI18n } from 'vue-i18n'
import BaseInnerLoader from 'components/Loader/BaseInnerLoader.vue'
import BaseModal from 'components/Modal/BaseModal.vue'
import FooterEvidenciaDefault from 'components/Footer.vue/FooterEvidenciaDefault.vue'
import HeaderModalEvidencia from 'components/Header/HeaderModalEvidencia.vue'
import OButton from 'components/Button/OButton.vue'
import SectionCaseSucesso from 'components/Evidencia/SectionCaseSucesso.vue'
import SectionContatoCase from 'components/Evidencia/SectionContatoCase.vue'
import SectionDefault from 'components/Evidencia/SectionDefault.vue'
import SectionTemplate from 'components/Evidencia/SectionTemplate.vue'
import useModal from 'composables/useModal'

const { t } = useI18n()

const modalEvidenciaCreate = useModal()
const { state, open, close, setState } = modalEvidenciaCreate
const { loading } = useEvidencia()

const sectionRef = ref(null)

function onChangeAba(aba) {
  abaAtiva.value = aba
}

async function onClickSave() {
  const form = sectionRef.value.formRef
  const files = sectionRef.value.model.files
  if (files.length === 0) {
    NotifyError(t('atLeastOneFileRequired'))
    return
  }
  const valid = await form.validate()
  if (!valid) return

  emits('click:save', sectionRef.value.model)
}

const abaAtiva = ref('Default')

const componentes = {
  Default: SectionDefault,
  Template: SectionTemplate,
  CaseSucesso: SectionCaseSucesso,
  Contato: SectionContatoCase,
}

const emits = defineEmits(['update:files', 'click:save'])

const onClose = () => {
  close()
}

setState({
  header: { title: t('evidences'), showProgress: true },
  style: { width: '50rem', minHeight: '80vh' },
})

defineExpose({
  state,
  open,
  close,
  setState,
})
</script>
